export const apiRoutes = {
  betaRegistrations: '/api/v1/beta-registrations',
  adminBeta: '/api/v1/admin/beta',
  toneAnalysis: '/api/v1/tone-analysis',
  videoPreview: '/api/v1/video-preview',
} as const
